import React from 'react';
import { useTranslation } from 'react-i18next';
import { HandDrawnButton } from '../shared/HandDrawnButton/HandDrawnButton';
import './ContactUsSantaCatarina.css';

const ContactUsSantaCatarina: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="contact-us-santa-catarina">
      <div className="contact-us-content">
        <h2 className="contact-us-title">{t('forms.contact.title')}</h2>
        <p className="contact-us-description">
          {t('properties/santa-catarina:contact.description')}
        </p>
        
        <form className="contact-form">
          <div className="form-row">
            <input 
              type="text" 
              placeholder={t('forms.contact.labels.firstName')} 
              className="form-input half-width"
              required
            />
            <input 
              type="text" 
              placeholder={t('forms.contact.labels.lastName')} 
              className="form-input half-width"
              required
            />
          </div>
          
          <div className="form-row">
            <input 
              type="email" 
              placeholder={t('forms.contact.labels.email')} 
              className="form-input half-width"
              required
            />
            <input 
              type="tel" 
              placeholder={t('forms.contact.labels.phoneNumber')} 
              className="form-input half-width"
            />
          </div>
          
          <div className="form-row">
            <select className="form-input half-width">
              <option value="">{t('forms.contact.labels.selectProperty')}</option>
              <option value="santa-catarina">{t('forms.contact.properties.santaCatarina')}</option>
              <option value="patagonia">{t('forms.contact.properties.patagonia')}</option>
              <option value="atacama">{t('forms.contact.properties.atacama')}</option>
              <option value="iguazu">{t('forms.contact.properties.iguazu')}</option>
              <option value="mendoza">{t('forms.contact.properties.mendoza')}</option>
            </select>
            <input 
              type="text" 
              placeholder={t('forms.contact.labels.country')} 
              className="form-input half-width"
            />
          </div>
          
          <textarea 
            placeholder={t('forms.contact.placeholders.additionalInfo')} 
            className="form-textarea"
            rows={6}
          />
          
          <HandDrawnButton
            text={t('forms.contact.buttons.submit')}
            onClick={() => {
              // Form submission logic would go here
              console.log('Form submitted');
            }}
            variant="santa-catarina"
            color="off-white"
            animation="fill-to-stroke"
            size="wide"
            className="contact-form-submit-button"
          />
        </form>
        
        <div className="contact-info">
          <p>{t('properties/santa-catarina:contact.directContactTitle')}</p>
          <div className="contact-section">
            <h4>{t('properties/santa-catarina:contact.reservations')}</h4>
            <a href="tel:+56222339641" className="contact-link">+(56-2) 2233-9641</a>
          </div>
          <div className="contact-section">
            <h4>{t('properties/santa-catarina:contact.emailInquire')}</h4>
            <a href="mailto:info@awasi.com" className="contact-link">info@awasi.com</a>
          </div>
          <div className="contact-section">
            <h4>{t('forms.contact.properties.santaCatarina')}:</h4>
            <p>Rua Elpídeo Alves do Nascimento, 104 Governador Celso Ramos – SC</p>
            <p>Phone Number + 55 48 3262-5040</p>
            <p>WhatsApp + 55 48 3262-5000</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsSantaCatarina;